export default __webpack_public_path__ + "static/favicon-074f19f5838418978d874b83a68bf249.ico";